import React, { useState } from "react";
import OtpInput from "react-otp-input";
import useApp from "../../hooks/useApp";
import "./style.scss";
import CountDownTimer from "../CountDownTimer";
import { useTranslation } from "react-i18next";
import { EVENT_NAME } from "../../constants";
import { logAnalyticEvent } from "../../analytics";

const CustomOTPInput = ({
  code,
  setCode,
  otpNotRecieve,
  resendCode,
  resend,
  otpLength,
  resendOtp,
  otpAttemptLeft,
}) => {
  const { isRTL, tenantConfig } = useApp();
  const [showCountdownTimer, setShowCountdownTimer] = useState(true);
  const { t } = useTranslation();

  const otpLengthFromConfig = tenantConfig?.otp_setting?.content?.length || 0;

  const handleResendOtp = () => {
    resendOtp();
    setShowCountdownTimer(true);
    logAnalyticEvent(EVENT_NAME.RESEND_OTP, {});
  };

  return (
    <div className="custom-otp-input-container">
      <OtpInput
        value={code}
        onChange={setCode}
        numInputs={otpLengthFromConfig}
        containerStyle={`otp-input-container`}
        inputStyle={"otp-input"}
        inputType={"number"}
        renderInput={(props, index) => (
          <input
            {...props}
            onChange={(e) => {
              props.onChange?.(e);
              if (index === otpLengthFromConfig - 1) {
                e.target?.blur();
              }
            }}
          />
        )}
      />
      <div className="footer-container">
        {otpAttemptLeft ? (
          <span className={`otp-attempt-left-text`}>
            {t("app.attempt_left_to_login", { attemptLeft: otpAttemptLeft })}
          </span>
        ) : null}
        <div className="resend-container">
          <span className={`resend-text ${isRTL ? "resend-text-rtl" : ""}`}>
            {showCountdownTimer ? resendCode : otpNotRecieve}
          </span>
          {showCountdownTimer ? (
            <CountDownTimer
              initialSeconds={30}
              onCountdownEnd={() => setShowCountdownTimer(false)}
            />
          ) : (
            <span className="resend-link" onClick={() => handleResendOtp()}>
              {resend}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomOTPInput;
